<template lang="pug">
v-app
  router-view
  dialog-notificacao(ref="dialogNotificacao")
  dialog-onboarding(ref="dialogOnboarding")
</template>

<script>
import _ from 'lodash';
import io from 'socket.io-client';
import axios from 'axios';
import store from '.././store';
import DialogNotificacao from '@/components/dialog/DialogNotificacao';
import DialogOnboarding from '@/components/dialog/DialogOnboarding';
import getBrowserFingerprint from '@/util/fingerPrint';

export default {
  components: {
    DialogNotificacao,
    DialogOnboarding,
  },
  data () {
    return {
      socket: null,
      connected: null,
      connecting: null,
    };
  },
  computed:{
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    estabelecimentos(){
      return this.$root.estabelecimentos
    },
  },
  watch: {
    '$root.printerConnected'(newValue) {
      this.emitImpressoraConectada(newValue);
    },
    '$root.isOnboardingPendente'(newValue) {
      if (!newValue) {
        this.notificacoesPendentes();
      }
    },
  },
  async beforeRouteEnter (to, from, next) {
    try {
      if (to.query && to.query.login) {
        next();
        return;
      }
      const user = _.cloneDeep(store.getters.user);
      const token = _.cloneDeep(store.getters.token);
      if (user) {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/login/validate`, user, {
          headers: {
            authorization: process.env.VUE_APP_AUTH_KEY,
            token: token ? token : user.token,
          },
        });

        store.dispatch('setToken', response.data.token);
        store.dispatch('setUser', _.merge(user, response.data));

        next();
      } else {
        window.getApp.$emit("APP_LOGOUT");
        next({ path: '/login' });
        return;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        window.getApp.$emit("APP_LOGOUT");
        next({ path: '/login' });
        return;
      }
      next();
    }
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.notificacoesPendentes);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

    // Desconectar socket adequadamente
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  },
  created(){
    if (this.$route.query.login) {
      this.$router.replace({ path: this.$route.path });
    }

    window.addEventListener('focus', this.notificacoesPendentes);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    window.getApp.$on("CHANGE_ESTABELECIMENTO", () => {
      console.log('CHANGE_ESTABELECIMENTO', this.estabelecimentoSelecionado)
      this.init();
    });
    window.getApp.$on('OPEN_ONBOARDING', () => {
      if (this.$refs.dialogOnboarding) this.$refs.dialogOnboarding.open();
    });
    window.getApp.$on('OPEN_TUTORIAL', (campo) => {
      if (this.$refs.dialogOnboarding) this.$refs.dialogOnboarding.openTutorial(campo);
    });
    window.getApp.$on('NOTIFICACAO', () => {
      this.notificacoesPendentes()
    })
    window.getApp.$on('APP_UPDATE_CONFIG_DELIVERY', configuracoesDelivery => {
      this.emitConfiguracoesDelivery(configuracoesDelivery);
    })
  },
  async mounted () {
    try{
      await this.getEstabelecimentos();
      if (this.$root.ringtone)
        this.$root.selectRingtone(this.$root.ringtone);
      else
        this.$root.selectRingtone(this.$root.optionsRingtones[0]);

      if (this.$root.driver && (this.$root.driver.id == 2 || this.$root.driver.id == 4)) {
        await this.$root.connectPrinter();
      }
    }catch(error){
      console.error('ERRO AO CONECTAR IMPRESSORA', error)
    }

    this.setDefaultEstabelecimento();

    await this.$root.fetchOnboarding(true);

    this.notificacoesPendentes()
    this.init();
    this.$root.validateQZPrinters();
  },
  methods: {
    notificacoesPendentes() {
      const vm = this;

      if (vm.$root.isOnboardingPendente) {
        return 0;
      }

      let lastAccess = vm.$root.lastAccessNotification;

      if (!lastAccess || typeof lastAccess != 'string') {
        lastAccess = vm.$dayjs().format();
        vm.$root.setLastAccessNotification(lastAccess);
        return 0;
      }

      let notificacoesNaoLidas = _.filter(vm.$root.notificacoes, n =>
        vm.$dayjs(lastAccess).isBefore(vm.$dayjs(n.data_envio, 'YYYY-MM-DD HH:mm:ss'))
      );

      if(notificacoesNaoLidas && notificacoesNaoLidas.length > 0) {
        let notificacaoMaisRecenteNaoLida = _.maxBy(notificacoesNaoLidas, n =>
          vm.$dayjs(n.data_envio, 'YYYY-MM-DD HH:mm:ss').unix()
        );

        vm.$nextTick(() => {
          vm.exibirDialogNotificacao(notificacaoMaisRecenteNaoLida);
        });
      }

      return notificacoesNaoLidas.length || 0;
    },
    exibirDialogNotificacao(notificacao) {
      if (this.$refs.dialogNotificacao) {
        this.$refs.dialogNotificacao.abrir(notificacao);
      }
    },
    init(){
      console.log('INIT DELIVERY')
      this.$root.getBoletos(this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null);
      this.$root.getPromocoes(this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null);
      this.$root.getNotificacoes()
      this.$root.getToken();
      this.initSocket();
      window.getApp.$emit("UPDATE_DELIVERY_TOOLBAR", this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null);
    },
    setDefaultEstabelecimento(){

      let estabelecimentoSelecionado = this.estabelecimentoSelecionado ? _.find(this.estabelecimentos, (o)=>{
        return o.id == this.estabelecimentoSelecionado.id
      }) : null;

      if(!estabelecimentoSelecionado && this.estabelecimentos.length == 1){
        estabelecimentoSelecionado = this.estabelecimentos[0];
      }

      this.$store.dispatch('setEstabelecimentoSelecionado', estabelecimentoSelecionado);
      this.$forceUpdate()
    },
    ping () {
      this.socket.emit('ping');
      this.emitConfiguracoesDelivery();
      this.emitImpressoraConectada(this.$root.printerConnected);
    },
    emitConfiguracoesDelivery (configuracoesDelivery) {
      if (this.socket) {
        const fingerprint = getBrowserFingerprint({ enableScreen: false });
        const config = configuracoesDelivery || _.cloneDeep(this.$store.getters.currentConfig);
        this.socket.emit('configuracoesDelivery', { ...config, fingerprint });
      }
    },
    emitImpressoraConectada (impressoraConectada) {
      if (this.socket) {
        this.socket.emit('impressoraConectada', impressoraConectada);
      }
    },
    connectSocket () {
      const vm = this;

      vm.socket = io.connect(process.env.VUE_APP_SOCKET, { transports: ['websocket'] });

      vm.socket.on("connect", e => {
        vm.$root.socket_connected = true;
        console.log("CONNECTED");
        vm.initSocket();
        vm.ping();
        if (this.estabelecimentoSelecionado) {
          vm.checkStatusStore([this.estabelecimentoSelecionado]);
        }
      });

      vm.socket.on("connect_error", e => {
        console.log("connect_error", e);
      });

      vm.socket.on("disconnect", e => {
        vm.$root.socket_connected = false;
        console.log("DISCONNECTED");
      });

      vm.socket.on("pong", e => {
        vm.ping();
      });

      vm.socket.on("open", delivery => {
        window.getApp.$emit('APP_UPDATE_DELIVERY', delivery);
        if (!vm.$root.estabelecimentoSelecionado || (vm.$root.estabelecimentoSelecionado && vm.$root.estabelecimentoSelecionado.id == delivery.estabelecimento_id)) {
          window.getApp.$emit('APP_ALERT', { color: 'success', text: "O Delivery está ABERTO!" });
        }
      });

      vm.socket.on("close", delivery => {
        window.getApp.$emit('APP_UPDATE_DELIVERY', delivery);
        if (!vm.$root.estabelecimentoSelecionado || (vm.$root.estabelecimentoSelecionado && vm.$root.estabelecimentoSelecionado.id == delivery.estabelecimento_id)) {
          window.getApp.$emit('APP_ALERT', { color: 'red', text: "O Delivery está FECHADO!" });
        }
      });

      vm.socket.on("pedido", async pedido => {
        try {
          pedido = await vm.$root.getPedido(pedido.id);
          vm.$root.allPedidos = [...vm.$root.allPedidos.slice(0, 0), pedido, ...vm.$root.allPedidos.slice(0)];
          if (!vm.$root.estabelecimentoSelecionado || (vm.$root.estabelecimentoSelecionado && vm.$root.estabelecimentoSelecionado.id == pedido.estabelecimento_id)) {
            vm.$root.ringBell({ once: pedido.status != 0 });
          }
          if (
            vm.$root.confirmation
            && vm.$root.confirmation.id == 2
            && (!vm.$root.printerConnected || !vm.$root.print || vm.$root.print.id != 2)
            && pedido.status == 0
          ) {
            window.getApp.$emit('APP_ALERT', { color: 'orange darken-1', text: "Não foi possível realizar a confirmação automática. Certifique que o QZ está conectado e a impressão automática está habilitada." });
          }
        } catch (error) {
        }
      });

      vm.socket.on("timerPedido", async e => {
        vm.$root.allPedidos.map(pedido => {
          if (pedido.id == e.pedido.id) {
            const timeLeft = _.padStart(e.pedido.timeLeft, 2, 0);
            if (pedido.timeLeft != timeLeft) {
              pedido.status = e.pedido.status;
              pedido.motivo = e.pedido.motivo;
              pedido.timeLeft = pedido.status == 0 ? timeLeft : null;
              window.getApp.$emit('APP_UPDATE_PEDIDOS', pedido);
            }
          }
        });
      });

      vm.socket.on("waitingPedidos", pedidos => {
        const estabelecimentoIds = pedidos.map(o => parseInt(o.estabelecimento_id))
        if (!vm.$root.estabelecimentoSelecionado || (vm.$root.estabelecimentoSelecionado && estabelecimentoIds.includes(vm.$root.estabelecimentoSelecionado.id))) {
          vm.$root.ringBell();
        }
      });

      vm.socket.on("updatePedido", pedidoUpdated => {
        vm.$root.allPedidos.map(pedido => {
          if (pedido.id == pedidoUpdated.id) {
            pedido.status = pedidoUpdated.status;
            pedido.motivo = pedidoUpdated.motivo;
            pedido.timeLeft = null;
            window.getApp.$emit('APP_UPDATE_PEDIDOS', pedido);
          }
        });
      });

      vm.socket.on("printPedido", pedidoPrint => {
        if (
          pedidoPrint.status == 1
          && vm.$root.print
          && vm.$root.print.id == 2
          && vm.$root.confirmation
          && vm.$root.confirmation.id == 2
          && vm.$root.driver
          && vm.$root.driver.id == 2
          && vm.$root.printer
          && vm.$root.printer.length > 0
          && vm.$root.printerConnected
        ) {
          vm.$root.printPedido(pedidoPrint);
        }
      });

      vm.socket.on("contatoSuporte", contato => {
        vm.$root.allPedidos.map(pedido => {
          if (pedido.id == contato.pedido_id) {
            pedido.suporte.push(contato);
            window.getApp.$emit('APP_UPDATE_PEDIDOS', pedido);
          }
        });
      });

      vm.connected = vm.socket.connected;
      vm.connecting = vm.socket.connecting;
    },
    initSocket() {
      const vm = this;
      if (vm.socket) {
        vm.socket.emit("initUser", {
          ...vm.$root.user,
          estabelecimentos: vm.estabelecimentos.map(o => ({
            id: o.id,
            localidade_id: o.localidade_id,
            delivery: o.delivery,
          })),
        });
        vm.getPedidos();
      }
    },
    selectPedido (pedido) {
      const vm = this;
      vm.$root.pedido = pedido;
    },
    async getPedidos () {
      const vm = this;
      try {
        const response = await vm.$axios.get('/pedido', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado ? vm.estabelecimentoSelecionado.id : null,
            interval: 6,
            orderDesc: "data",
            valido : true
          }
        });
        vm.pedidos = response.data;
        vm.$root.allPedidos = response.data;
        if (response.data.length) {
          // Mantém o pedido já selecionado (ex: aberto pela Home) se ele ainda existir na lista
          const pedidoAtual = vm.$root.pedido && _.find(response.data, { id: vm.$root.pedido.id });
          vm.selectPedido(pedidoAtual || response.data[0]);
        } else {
          vm.$root.pedido = null;
        }
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao carregar os pedidos!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    handleBeforeUnload(event) {
      // Desconectar socket antes do usuário sair da página
      if (this.socket) {
        this.socket.disconnect();
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        // Página ficou oculta (usuário mudou de aba ou minimizou)
        // console.log('Página oculta - mantendo conexão socket');
      } else {
        // Página ficou visível novamente
        // console.log('Página visível - verificando conexão socket');
        if (!this.socket || !this.socket.connected) {
          this.connectSocket();
        }
      }
    },
    async getEstabelecimentos () {
      const vm = this;
      try {
        const response = await vm.$axios.get('/estabelecimento', {
          params: {
            delivery: true,
            ativo: 1,
            status_venda_delivery: [0,1,4],
            fields: 'delivery,vendas',
            columns: 'localidade,estado',
          },
        });

        const estabelecimentos = response.data.filter(e => e && e.delivery && e.delivery.length ? true : false);
        vm.$store.dispatch('setEstabelecimentos', estabelecimentos);
        vm.connectSocket();

      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao carregar os estabelecimentos!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    async checkStatusStore(estabelecimentos){
      if (!estabelecimentos || estabelecimentos.length == 0) return;

      const vm = this;
      const estabelecimentoIds = estabelecimentos.map(estabelecimento => estabelecimento.id);

      try {
        const response = await vm.$axios.get('/check-status', {
          params: {
            ids: estabelecimentoIds
          }
        });

        const statusAtualizados = response.data;
        if(statusAtualizados && Array.isArray(statusAtualizados)){
          const abertoPorEstabelecimento = statusAtualizados.reduce((reduced, statusAtualizado) => {
            reduced[statusAtualizado.estabelecimento_id] = statusAtualizado.aberto;
            return reduced;
          }, {});

          const aplicarStatus = (estabelecimento) => {
            const aberto = abertoPorEstabelecimento[estabelecimento.id];

            if (aberto == null || !estabelecimento.delivery || !estabelecimento.delivery.length) {
              return estabelecimento;
            }

            return {
              ...estabelecimento,
              aberto: aberto,
              delivery: [{ ...estabelecimento.delivery[0], aberto: aberto }, ...estabelecimento.delivery.slice(1)],
            };
          };

          vm.$store.dispatch('setEstabelecimentos', vm.estabelecimentos.map(aplicarStatus));

          if(vm.estabelecimentoSelecionado && abertoPorEstabelecimento[vm.estabelecimentoSelecionado.id] != null) {
            vm.$store.dispatch('setEstabelecimentoSelecionado', aplicarStatus(vm.estabelecimentoSelecionado));

            window.getApp.$emit("UPDATE_DELIVERY_TOOLBAR", vm.estabelecimentoSelecionado.id);
          }
        }
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao atualizar os estabelecimentos!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
